export default "__VITE_ASSET__BGeed604__"